<template>
  <upload @btn-update="handleStyle"/>
</template>
<script>
//有时组件内部是动态加载，dom是变化的，所以此处支持监听子组件更新事件上报
import upload from "../base/Upload";
export default {
  components: { upload },
  mounted() {
    this.handleStyle();
  },
  methods: {
    handleStyle() {
      this.$nextTick(x => {
        //处理个性化样式
        let dom = document.querySelector("a[class='btn-submit']");
        let dom2 = document.querySelector("div[class='out-upload-input']");
        let dom3 = document.querySelector("a[class='btn-reUpload']");
        if (dom) {
          dom.classList.add("au-submit");
        }
        if (dom2) {
          dom2.classList.add("au-submit");
        }
        if (dom3) {
          dom3.classList.add("au-reUpload");
        }
      });
    }
  }
};
</script>

<style lang="scss">
.au-submit {
  display: block;
  width: 6.8rem;
  height: 1.08rem;
  font-size: 0.32rem;
  line-height: 1.08rem;
  text-align: center;
  font-family: "HelveticaNeue-Medium";
  color: #fff;
  background: linear-gradient(45deg, #ff5b1d, #ff7f41);
  border-radius: 6px;
}
.au-reUpload {
  display: block;
  width: 6.8rem;
  height: 1.08rem;
  font-size: 0.32rem;
  line-height: 1.08rem;
  text-align: center;
  font-family: "HelveticaNeue-Medium";
  color: #ff7226;
  background: #fff;
  border: 1px solid #ff7226;
  border-radius: 6px;
}
</style>


